import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useHandleShowDialogs } from 'forms/hooks';
import { useDispatch, useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { fetchCampaignDetail, saveCampaignSettings } from 'features/views/campaignSettings/campaignDetail/actions';
import formDescriptorFn, {
	CAMPAIGN_SETTINGS_CAMPAIGN_FORM_NAME,
} from 'features/views/campaignSettings/campaignDetail/form';
import { getDetail } from 'features/views/campaignSettings/campaignDetail/selectors';

import CampaignWave from './components/CampaignWave';
import Description from './components/Description';
import MaterialsOrder from './components/MaterialsOrder';
import Parameters from './components/Parameters';
import RenderedColumns from './components/RenderedColumns';

export const Campaign = ({ campaignId }) => {
	const dispatch = useDispatch();
	const campaignDetail = useSelector(getDetail);

	useEffect(() => {
		dispatch(fetchCampaignDetail(campaignId));
	}, [dispatch, campaignId]);

	const handleSubmit = useCallback(() => {
		dispatch(saveCampaignSettings(campaignId));
	}, [dispatch, campaignId]);

	const handleShowDialogsForSubmit = useHandleShowDialogs({
		page: CAMPAIGN_SETTINGS_CAMPAIGN_FORM_NAME,
		continueFn: handleSubmit,
	});

	return (
		<Form name={CAMPAIGN_SETTINGS_CAMPAIGN_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Stack spacing={3}>
				<CampaignWave campaignDetail={campaignDetail} />
				<Parameters campaignType={campaignDetail.type} />
				<RenderedColumns />
				<MaterialsOrder campaignType={campaignDetail.type} />
				<Description />
				<Grid
					container
					sx={{
						justifyContent: 'center',
					}}
				>
					<Grid size={4}>
						<ComponentLoader
							fetchStorePath={`${fetch.constants.urls.campaignDetail}.put`}
							onReload={handleSubmit}
						>
							<SubmitButton
								variant="contained"
								onClick={handleSubmit}
								onClickError={handleShowDialogsForSubmit}
								fullWidth
								text={getLabelMessage('common:save')}
							/>
						</ComponentLoader>
					</Grid>
				</Grid>
			</Stack>
		</Form>
	);
};

Campaign.propTypes = {
	campaignDetail: PropTypes.object,
	campaignId: PropTypes.number,
};

export default Campaign;
